import React from "react";
import { Survey } from "./survey-types";
import { useOutletContext } from "react-router-dom";
import { downloadResults } from "../export/ExportService";
import { SurveyResults } from "../survey-results/survey-results-types";

export const ExportTab: React.FC = () => {
  const { survey, results } = useOutletContext<{
    results: SurveyResults | undefined;
    survey: Survey | undefined;
  }>();

  function handleExportResults() {
    if (!survey || !results) {
      alert("Please first compute the survey responses.");
      return;
    }
    //TODO try catch
    downloadResults(survey, results);
  }

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h3 className="text-xl mb-4">Aggregated Results</h3>
        <button className="btn-primary" onClick={handleExportResults}>
          Export as CSV
        </button>
        <button
          className="btn-primary"
          onClick={() => alert("Not implemented yet")}
        >
          Export as Powerpoint
        </button>
      </div>

      <div>
        <h3 className="text-xl mb-4">Granular Results</h3>
        <button
          className="btn-primary"
          onClick={() => alert("Not implemented yet")}
        >
          Export as CSV
        </button>
      </div>
    </div>
  );
};
